<template>
  <template v-if="order.has_discount">
    <p class="text-gray-900 text-sm">Итого без скидки: <strong>{{ order.original_total_price.full }}</strong></p>
    <p class="text-gray-900 text-sm mb-4">
      Скидка: <strong>{{ order.discount_difference.full }} ({{ order.discount_percentage.percentage }}%)</strong>
    </p>
  </template>
  <p class="text-gray-900 text-sm">Итого к оплате: <strong>{{ order.total_price.full }}</strong></p>
  <ul>
    <li v-if="hasBonusesPayment" class="text-gray-900 text-sm">
      Оплачено бонусами: <strong>{{ bonuses.amount.full }}</strong>
    </li>
    <li class="text-gray-900 text-sm" v-for="payment in payments">
      {{ payment.method.name }}: <strong>{{ payment.amount.full }}</strong>
      <template v-if="payment.meta && payment.meta.change && payment.meta.change.full"> (сдача: {{ payment.meta.change.full }})</template>
      <template v-if="isOnlinePayment(payment)">
        <template v-if="payment.status.id === 'confirmed'"> (оплата подтверждена)</template>
        <template v-else-if="payment.status.id === 'refunded'"> (платёж возвращён)</template>
        <template v-else-if="payment.status.id === 'cancelled'"> (оплата отменена)</template>
        <template v-else> (не оплачено)</template>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    order: {
      required: true,
      type: Object,
    },
  },

  computed: {
    hasBonusesPayment() {
      return !!this.bonuses
    },

    bonuses() {
      return this.order.payments.find(payment => payment.method.id === 'bonuses')
    },

    payments() {
      return this.order.payments.filter(payment => payment.method.id !== 'bonuses')
    },
  },

  methods: {
    isOnlinePayment(payment) {
      return ['cloudpayments', 'card_token'].indexOf(payment.method.id) !== -1
    },
  },
}
</script>
